@if (options != undefined && options.length > 0) {
  <p-select
    [autofocus]="false"
    [options]="options"
    [(ngModel)]="selectedOption"
    placeholder="Status:"
    class="w-full"
    optionValue="value"
    [showClear]="true"
    (onChange)="onSelect.emit($event.value ?? undefined)"
    [dt]="dropdownStyle"
  >
    <ng-template #selectedItem let-selectedOption>
      <div class="flex align-items-center gap-1 white-space-nowrap">
        <span class="text-sm-medium text-gray-500">Status:</span>
        <span class="text-sm-semibold text-gray-900">{{selectedOption.description}}</span>
      </div>
    </ng-template>
    <ng-template #dropdownicon>
      <app-chevron-right class="dropdown-chevron" direction="down" stroke="#ADB0B8" width="7px" height="12px"></app-chevron-right>
    </ng-template>
    <ng-template let-option #item>
      <div class="flex align-items-center gap-2">
        <app-dot width="10px" height="10px" [stroke]="getStrokeByStatus(option.value)"></app-dot>
        <div class="text-sm-semibold text-gray-700">{{option.description}}</div>
      </div>
    </ng-template>
  </p-select>

}
